import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as galleryActions from '../../actions/gallery/galleryActions';
import * as galleryImageAction from '../../actions/gallery/galleryImageActions';
import * as spinnerActions from '../../actions/spinnerActions';
import * as modalActions from '../../actions/common/modalActions';
import {Link} from 'react-router-dom';
import { injectIntl } from 'react-intl';
import WithResolvedPromises from "../common/WithResolvedPromises";
import PlaceholderError from "../common/PlaceholderError";
import Placeholder from "../Placeholder";
import Reorder from 'react-reorder';
import GalleryImage from "./GalleryImage";
import {toastr} from "react-redux-toastr";
import CustomModal from "../CustomModal";
import {messages} from "../common/Translations";

class GalleryViewPage extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.deleteGalleryImageId = null;

        this.actions = this.getRequiredActions();
        this.state = {
            isReordering: false,
            showModal: false,
        };

        this.onDelete = this.onDelete.bind(this);
    }

    getRequiredActions() {
        let actions = [];
        actions.push(this.props.actions.getGallery(this.props.match.params.id));
        actions.push(this.props.actions.loadGalleryImages(this.props.match.params.id));
        return actions;
    }

    onReorderSubmit() {
        let galleryImagesIds = this.props.galleryImages.map((galleryImage) => {
            return galleryImage.id;
        });
        this.setState({...this.state, isReordering: true});
        this.props.actions.reorderGalleryImages(
            this.props.match.params.id,
            galleryImagesIds
        ).finally(() => {
            this.setState({...this.state, isReordering: false});
        });
    }

    onReorder (event, previousIndex, nextIndex, fromId, toId) {
        this.props.actions.swapGalleryImages(
            previousIndex,
            nextIndex,
            this.props.galleryImages
        );
    }

    onDelete(imageId) {
        this.deleteGalleryImageId = imageId;
        this.props.actions.showModal();
    }

    hideDeleteModal() {
        this.deleteGalleryImageId = null;
        this.props.actions.hideModal();
    }

    deleteGalleryImage() {
        if (this.deleteGalleryImageId !== null) {
            this.props.actions.deleteGalleryImage(this.props.match.params.id, this.deleteGalleryImageId).then(() => {
                this.deleteGalleryImageId = null;
                this.props.actions.loadGalleryImages(this.props.match.params.id);
                this.props.actions.hideModal();
                toastr.success('Billedet blev slettet');
            });
        } else {
            toastr.error('Kunne ikke slette billedet');
            this.props.actions.hideModal();
        }
    }

    render() {
        const gallery = this.props.gallery;
        const galleryImages = this.props.galleryImages;

        return (
            <WithResolvedPromises preloaderComponent={Placeholder} promises={this.actions} errorComponent={PlaceholderError}>
            <div>
                <CustomModal
                    modalTitle={'Slet billede'/*this.props.intl.formatMessage(messages.galleryDeleteModalTitle)*/}
                    modalContent={<p>Er du sikker på, at du vil slette billedet? Du skal være opmærksom på at handlingen ikke kan fortrydes!</p>/*<p>{this.props.intl.formatMessage(messages.galleryDeleteQuestion)}</p>*/}
                    confirmText={this.props.intl.formatMessage(messages.deleteModalConfirmButton)}
                    closeText={this.props.intl.formatMessage(messages.deleteModalCancelButton)}
                    handleConfirm={() => {this.deleteGalleryImage()}}
                    handleHideModal={() => {this.hideDeleteModal()}}
                    isOpen={this.props.showModal}
                />
                <div className="row">
                    <div className="col-12">
                        <div className="card m-b-20">
                            <div className="card-block">
                                <h1 className="mb-3">Galleri {/*this.props.intl.formatMessage(messages.gallery)*/}</h1>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="row">
                                            <div className="col-sm-2"><p><b>Navn</b></p></div>
                                            <div className="col-md-10"><p>{gallery.name}</p></div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-2"><p><b>Beskrivelse</b></p></div>
                                            <div className="col-md-10"><p>{gallery.description}</p></div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 text-right"><Link
                                        to={`/galleri/rediger/${gallery.id}`}
                                        className="btn btn-primary waves-effect list-action"
                                    >
                                        <i className="fa fa-pencil"/> Ret tekster
                                    </Link>
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <div className="col-sm-6">
                                        <h2 className="mb-3">Billeder{/*this.props.intl.formatMessage(messages.galleryListTitle)*/}</h2>
                                    </div>
                                    <div className="col-sm-6 pt-2">
                                        <Link
                                            to={`/galleri-billede/skab/${gallery.id}`}
                                            className="btn btn-primary waves-effect pull-right list-create-button"
                                        >
                                            Upload et billede {/*this.props.intl.formatMessage(messages.galleryCreate)*/}
                                        </Link>
                                    </div>
                                </div>
                                <Reorder
                                    reorderId="gallery-list"
                                    component="div"
                                    draggedClassName="dragged dragged-cursor"
                                    onReorder={this.onReorder.bind(this)}
                                    disableReorder={this.state.isReordering}
                                >
                                    {
                                        galleryImages.map((galleryImage) => {
                                                let cssClass = (galleryImage.position % 2 == 0) ? "row-even" : "row-odd"
                                                return (
                                                    <div
                                                        className={cssClass}
                                                        key={galleryImage.position}>
                                                        <GalleryImage
                                                            galleryImage={galleryImage}
                                                            onDelete={this.onDelete}
                                                        />
                                                    </div>
                                                )
                                            }
                                        )
                                    }
                                </Reorder>
                                {
                                    (galleryImages.length > 1) &&
                                <div className={"row mt-5"}>
                                    <div className="col-sm-12">

                                        {
                                            !this.state.isReordering &&
                                            <button
                                                onClick={this.onReorderSubmit.bind(this)}
                                                className="btn btn-primary waves-effect list-create-button">
                                                Rækkefølge
                                            </button>
                                        }

                                        {
                                            this.state.isReordering &&
                                            <button disabled type="submit" className={`disabled btn btn-primary waves-effect list-create-button`}>
                                                <i className="fa fa-spin fa-spinner"/> Arbejder...
                                            </button>
                                        }

                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </WithResolvedPromises>
        )
    }
}

function mapStateToProps(state, ownProps) {
    return {
        gallery: state.gallery,
        showModal: state.showModal,
        galleryImages: state.galleryImages,

    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...galleryActions,
            ...galleryImageAction,
            ...spinnerActions,
            ...modalActions,
        }, dispatch)
    }
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(GalleryViewPage));


// WEBPACK FOOTER //
// ./web/src/components/galleries/GalleryViewPage.jsx